// Auto-generated by splitter.py — do not regenerate; edit directly.

export const MOCK_ORG = {
  'Akibua Sports Ltd': {
    id: 'ORG-2008', name: 'Akibua Sports Ltd', legalName: 'Akibua Sports & Entertainment Ltd',
    tin: '1000489221', registration: '80020014219', founded: '12 Feb 2019',
    contact: 'Ronald M. Akibua', email: 'ronald@akibuasports.co.ug', phone: '+256 772 318 920',
    address: 'Plot 14, Kira Road, Kampala', country: 'Uganda',
    kyc: 'Verified', kycDate: '14 Feb 2025', tier: 'Tier 2 — Sports promoter',
    onboarded: '03 Mar 2024', accountManager: 'Brian O.',
    trustScore: 88, settlementReliability: 99.4, payoutHealth: 'Healthy', disputeRate: 0.18, refundRate: 1.4, fraudRisk: 'Low',
    grossLifetime: 4_820_400_000, netSettled: 4_618_200_000, pendingReserve: 84_000_000, rollingReserve: 64_200_000,
    chargebacks: 2, failedPayouts: 1, suspiciousVelocity: 0,
    activeEvents: 2, completedEvents: 14, cancelledEvents: 0, avgRevPerEvent: 268_900_000,
    bank: 'Stanbic Bank Uganda', bankAcct: '••••4421', bankVerified: '12 Mar 2024',
    momoVerified: '12 Mar 2024',
    teamUsers: [
      { name: 'Ronald Akibua', role: 'Admin', email: 'ronald@akibuasports.co.ug', last: '12m' },
      { name: 'Sandra Naluwooza', role: 'Finance', email: 'sandra@akibuasports.co.ug', last: '2h' },
      { name: 'Daniel Okwir', role: 'Operations', email: 'daniel@akibuasports.co.ug', last: '4h' },
    ],
  },
  'Swangz Avenue': {
    id: 'ORG-2014', name: 'Swangz Avenue', legalName: 'Swangz Avenue Records Ltd',
    tin: '1001202048', registration: '80020019910', founded: '08 May 2008',
    contact: 'Benon Mugumbya', email: 'benon@swangzavenue.com', phone: '+256 772 100 442',
    address: 'Plot 41, Bukoto Crescent, Kampala', country: 'Uganda',
    kyc: 'Verified', kycDate: '02 Apr 2025', tier: 'Tier 3 — Premium label',
    onboarded: '14 Jun 2023', accountManager: 'Esther N.',
    trustScore: 94, settlementReliability: 99.8, payoutHealth: 'Healthy', disputeRate: 0.09, refundRate: 0.8, fraudRisk: 'Low',
    grossLifetime: 8_412_800_000, netSettled: 8_188_100_000, pendingReserve: 22_400_000, rollingReserve: 84_120_000,
    chargebacks: 1, failedPayouts: 0, suspiciousVelocity: 0,
    activeEvents: 1, completedEvents: 26, cancelledEvents: 1, avgRevPerEvent: 312_400_000,
    bank: 'Stanbic Bank Uganda', bankAcct: '••••8201', bankVerified: '14 Jun 2023',
    momoVerified: '14 Jun 2023',
    teamUsers: [
      { name: 'Benon Mugumbya', role: 'Admin', email: 'benon@swangzavenue.com', last: '8m' },
      { name: 'Julian Tumusiime', role: 'Finance', email: 'julian@swangzavenue.com', last: '1d' },
    ],
  },
  'Talent Africa': {
    id: 'ORG-2002', name: 'Talent Africa', legalName: 'Talent Africa Group Ltd',
    tin: '1001408822', registration: '80020022084', founded: '11 Sep 2012',
    contact: 'Aly Allibhai', email: 'aly@talentafrica.com', phone: '+256 752 880 100',
    address: 'Plot 7, Lourdel Road, Nakasero, Kampala', country: 'Uganda',
    kyc: 'Pending verification', kycDate: '—', tier: 'Tier 3 — Festival operator',
    onboarded: '02 Jan 2022', accountManager: 'Victor S.',
    trustScore: 76, settlementReliability: 97.2, payoutHealth: 'Watching', disputeRate: 1.2, refundRate: 2.8, fraudRisk: 'Medium',
    grossLifetime: 12_140_600_000, netSettled: 11_602_400_000, pendingReserve: 280_400_000, rollingReserve: 184_200_000,
    chargebacks: 8, failedPayouts: 2, suspiciousVelocity: 1,
    activeEvents: 1, completedEvents: 18, cancelledEvents: 2, avgRevPerEvent: 624_800_000,
    bank: 'DFCU Bank', bankAcct: '••••7780', bankVerified: '02 Jan 2022',
    momoVerified: '—',
    teamUsers: [
      { name: 'Aly Allibhai', role: 'Admin', email: 'aly@talentafrica.com', last: '32m' },
      { name: 'Derrick Kavuma', role: 'Finance', email: 'derrick@talentafrica.com', last: '2h' },
      { name: 'Faith Namugga', role: 'Operations', email: 'faith@talentafrica.com', last: '1d' },
      { name: 'Henry Owino', role: 'Marketing', email: 'henry@talentafrica.com', last: '4h' },
    ],
  },
};


// Channel mix data

// Gate / scanner intelligence — per-event

export const COMMS_LOG = [
  { id: 'CMP-44', name: 'Match-day reminder (T-24h)', channel: 'WhatsApp', audience: 'All buyers', sent: 18420, delivered: 18108, opened: 14882, failed: 312, status: 'Sent',      time: '2h ago' },
  { id: 'CMP-43', name: 'Gate opens in 1h',           channel: 'SMS',      audience: 'All buyers', sent: 18420, delivered: 18402, opened: null,  failed:  18, status: 'Sent',      time: '6h ago' },
  { id: 'CMP-42', name: 'Final ticket release',       channel: 'Email',    audience: 'Wait list',  sent:  4280, delivered:  4242, opened:  2120, failed:  38, status: 'Sent',      time: '2d ago' },
  { id: 'CMP-41', name: 'VIP welcome pack',           channel: 'Email',    audience: 'VIP buyers', sent:   180, delivered:   180, opened:   168, failed:   0, status: 'Sent',      time: '3d ago' },
  { id: 'CMP-45', name: 'Match recap & next match',   channel: 'WhatsApp', audience: 'All buyers', sent:     0, delivered:     0, opened:     0, failed:   0, status: 'Scheduled', time: 'in 4h' },
];


export const ORG_COMMERCIAL = {
  'Akibua Sports Ltd': {
    commission: 5.0,        feePayer: 'Organizer',   payoutTiming: 'T+1', rollingReserve: 5.0, reserveDays: 90,
    refundAuthority: 'Organizer (with TKT review)',  transferPermission: 'Allowed · 24h cutoff', compPermission: 'Up to 2% of capacity',
    whiteLabel: 'Disabled',     settlementCurrency: 'UGX', preferredRail: 'EFT', payoutDayOfWeek: 'Any', minBatch: 500_000,
    riskTier: 'Tier 2',         autoApprovePayouts: false, maxAutoApproveAmount: 0,
  },
  'Swangz Avenue': {
    commission: 4.5,        feePayer: 'Organizer',   payoutTiming: 'T+1', rollingReserve: 3.0, reserveDays: 60,
    refundAuthority: 'Organizer (autonomous)',       transferPermission: 'Allowed · 24h cutoff', compPermission: 'Up to 3% of capacity',
    whiteLabel: 'Enabled · swangz.tkt.ug',           settlementCurrency: 'UGX', preferredRail: 'EFT', payoutDayOfWeek: 'Mon, Wed, Fri', minBatch: 1_000_000,
    riskTier: 'Tier 3',         autoApprovePayouts: true,  maxAutoApproveAmount: 50_000_000,
  },
  'Talent Africa': {
    commission: 5.5,        feePayer: 'Organizer',   payoutTiming: 'T+3 (held)', rollingReserve: 8.0, reserveDays: 120,
    refundAuthority: 'TKT only (org suspended)',     transferPermission: 'Allowed · 48h cutoff', compPermission: 'Up to 1% of capacity',
    whiteLabel: 'Disabled',     settlementCurrency: 'UGX', preferredRail: 'EFT', payoutDayOfWeek: 'After KYC refresh', minBatch: 1_000_000,
    riskTier: 'Tier 3 (watch)', autoApprovePayouts: false, maxAutoApproveAmount: 0,
  },
};

